import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, imgUrl } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { ArrowLeft } from "lucide-react";

export default function BlogDetail() {
  const { slug } = useParams();
  const { t, pick } = useLang();
  const [post, setPost] = useState(null);

  useEffect(() => {
    setPost(null);
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => {});
  }, [slug]);

  if (!post) return <div className="pt-40 px-6 text-center text-charcoal-400">Loading…</div>;

  return (
    <div data-testid="blog-detail-page" className="pt-24">
      <div className="h-[42svh] md:h-[54svh] overflow-hidden relative">
        <img src={imgUrl(post.cover_image)} alt={pick(post.title_en, post.title_fr)} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 px-6 md:px-12 pb-8 md:pb-12">
          <div className="max-w-3xl mx-auto">
            <Link to="/stories" className="inline-flex items-center gap-2 text-sand-50/80 hover:text-sand-50 text-sm mb-4">
              <ArrowLeft size={14} /> {t.nav.stories}
            </Link>
            <h1 className="font-serif-display text-3xl md:text-5xl tracking-tight font-light text-sand-50 leading-[1.1]">
              {pick(post.title_en, post.title_fr)}
            </h1>
          </div>
        </div>
      </div>
      <article className="max-w-3xl mx-auto px-6 md:px-0 py-12 md:py-16">
        <p className="font-serif-display text-2xl md:text-3xl text-charcoal leading-[1.4] font-light mb-10">
          {pick(post.excerpt_en, post.excerpt_fr)}
        </p>
        <div className="text-charcoal-400 text-base md:text-lg leading-relaxed whitespace-pre-line">
          {pick(post.content_en, post.content_fr)}
        </div>
      </article>
    </div>
  );
}
